import { render, staticRenderFns, recyclableRender, components } from "./factoryChange.vue?vue&type=template&id=640708fc&scoped=true&"
var renderjs
import script from "./factoryChange.vue?vue&type=script&lang=js&"
export * from "./factoryChange.vue?vue&type=script&lang=js&"
import style0 from "./factoryChange.vue?vue&type=style&index=0&lang=css&"
import style1 from "./factoryChange.vue?vue&type=style&index=1&id=640708fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640708fc",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/factoryChange/factoryChange.vue"
export default component.exports